module.exports = __webpack_public_path__ + "img/tw.de1acd89.jpg";